export { default } from './methodik.mdx'
export { default as Methodik } from './methodik.mdx'
